// File: IcebreakerCard.jsx (same component/API)
import React from 'react';

export default function IcebreakerCard({
  question = 'What is your personal mission?',
  colour = 'RED',
}) {
  const isRed = colour.toUpperCase() === 'RED';
  const colourName = isRed ? 'Red' : 'Blue';
  const targetColourName = isRed ? 'Blue' : 'Red';

  const hintText = ``;

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <span style={styles.pill}>Icebreaker</span>

        <h2 style={styles.question}>{question}</h2>

        <p style={styles.colourHint}>
          {/* eslint-disable-next-line react/no-danger */}
          <em dangerouslySetInnerHTML={{ __html: hintText }} />
        </p>
      </div>

      <p style={styles.footer}>
        When the timer reaches&nbsp;zero you'll automatically return to your portal page — make the most of
        this chat!
      </p>
    </div>
  );
}

const styles = {
  wrapper: {
    width: '100%',
    maxWidth: 600,
    margin: '0 auto',
    fontFamily: "'Open Sans', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    textAlign: 'center',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  card: {
    position: 'relative',
    padding: '7.5rem 1.5rem 3.25rem', // a touch tighter
    borderRadius: 12,
    border: '1px dashed #ddd',
    boxShadow: '0 4px 50px rgba(165,165,165,0.08)',
    margin: '1rem',
    minHeight: 260,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  pill: {
    position: 'absolute',
    top: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    color: '#555',
    fontWeight: 700,
    padding: '8px 16px',
    fontSize: '.8rem',
    background: '#eee',
    borderRadius: 100,
  },

  // ⬇️ Key improvements here
  question: {
    fontSize: '1.75rem',
    fontWeight: 550,                 // use a real, crisp weight
    lineHeight: 1.5,
    letterSpacing: '-0.02em',        // slight tightening improves polish
    textRendering: 'optimizeLegibility',
    margin: '0 auto',
    maxWidth: 360,                   // wider measure → fewer awkward breaks
    color: '#111',
    marginTop: '0.75rem',
    marginBottom: '1.75rem',         // less empty space before hint
  },

  colourHint: {
    marginTop: '0.75rem',
    fontSize: '.95rem',
    lineHeight: 1.5,
    color: '#60676f',
    maxWidth: 360,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  footer: {
    fontSize: '.75rem',
    lineHeight: 1.5,
    color: '#9ca3af',
    maxWidth: 300,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};
